/*eslint-disable */
<template>
  <b-modal v-model="showRoleEditModal" centered scrollable title="Edit Role" no-close-on-backdrop no-close-on-esc>
    <b-container fluid class="p-0" style="height: 500px;">
      <b-row>
        <b-col lg="12">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="vmRoleName"
              id="uname"
              :placeholder="cvRoleNameLabel"/>
          </div>
        </b-col>
        <b-col lg="12" class="mb-3">
          <b-form-input
            id="search"
            v-model="filter"
            type="search"
            placeholder="Search actions..."
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <div class="form-group">
            <b-form-group>
              <template #label>
                <b>{{ cvActionLabel }}:</b><br>
              </template>

              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group id="checkbox-group" v-model="vmSelectedActions" name="selectedUsers" stacked>
                  <b-form-checkbox
                    v-for="action in getFilteredActions()"
                    :key="action.action_id"
                    :value="action"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-4a"
                    stack>
                    <span style="cursor: pointer;">{{ action.action_name }}</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </template>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-toast
        v-model="showToast"
        name="Toast"
        :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
        :variant="toastVariant"
        :title="toastTitle">
        <div v-html="toastMsg">
        </div>
      </b-toast>
    </b-container>
    <template #modal-footer="">
      <b-button size="sm" class="pull-left" variant="secondary" @click="closeRoleEditModal()">
        Skip
      </b-button>
      <b-button size="sm" variant="primary" @click="udfRoleEdit()" :disabled="submitting">
        <b-spinner small class="ml-4 mr-4" v-if="submitting" label="Spinning">
        </b-spinner>
        <span v-else>Submit</span>
      </b-button>
    </template>
  </b-modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { UserRole } from "../../../FackApi/api/userRole"
import ApiResponse from "../../../Utils/apiResponse.js"
import userPermission from "../../../Utils/user_permission"

export default {
  name: "RoleEdit",
  props: {
    "propShowRoleEditModal": {
      default: false
    },
    "propRoleId": {
      default: false
    },
    propModuleName: {
      type: String,
      default: null,
      required: true
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  data () {
    return {
      apiName: "udfRole_edit",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Role",
      cvRoleNameLabel: "Enter a role name",
      cvActionLabel: "Select Actions for the role",
      showRoleEditModal: false,
      submitting: false,
      vmRoleName: null,
      udfActionObj: {},
      udfActionOptions: [],
      vmSelectedActions: [],
      prevActions: [],
      filter: ""
    }
  },
  mounted () {
  },
  methods: {
    /**
     * loadRequiredData
     */
    loadRequiredData () {
      this.submitting = false
      this.udfRoleView()
      this.udfActionList()
    },
    /**
     * udfActionList
     */
    async udfActionList () {
      let moduleName = this.propModuleName
      try {
        let udfActionListResp = await UserRole.udfActionList(this, moduleName)
        if (udfActionListResp && !udfActionListResp.resp_status) {
          return false
        }
        else {
          this.udfActionOptions = udfActionListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at udfActionList() and Exception:", err.message)
      }
    },
    /**
     * udfRoleView
     */
    async udfRoleView () {
      try {
        let udfRoleViewResp = await UserRole.udfRoleView(this, this.propRoleId)
        if (udfRoleViewResp && !udfRoleViewResp.resp_status) {
          return false
        }
        this.vmRoleName = udfRoleViewResp.resp_data.data.role.udr_name
        this.vmSelectedActions = udfRoleViewResp.resp_data.data.actions
      }
      catch (err) {
        this.submitting = false
        console.error("Exception occurred at udfRoleView() and Exception:", err.message)
      }
    },
    /**
     * udfRoleEdit
     */
    async udfRoleEdit () {
      if (!this.vmRoleName) {
        return false
      }

      let moduleObjId = null
      if (this.propModuleName === "CLUB") {
        moduleObjId = this.$route.params.club_id
      }
      else {
        moduleObjId = this.$route.params.org_id
      }

      this.submitting = true
      let moduleData = {
        udr_id: this.propRoleId,
        udr_name: this.vmRoleName,
        module_obj_id: moduleObjId
      }

      if (this.vmSelectedActions && this.vmSelectedActions.length > 0) {
        moduleData.actions = JSON.stringify(this.vmSelectedActions)
      }

      try {
        let udfRoleEditResp = await UserRole.udfRoleEdit(this, moduleData)
        await ApiResponse.responseMessageDisplay(this, udfRoleEditResp)
        if (udfRoleEditResp && !udfRoleEditResp.resp_status) {
          this.submitting = false
          return false
        }
        else {
          this.$emit("emitUdfRoleEdit", moduleData)
          this.submitting = false
          this.closeRoleEditModal()
        }
      }
      catch (err) {
        this.submitting = false
        console.error("Exception occurred at udfRoleEdit() and Exception:", err.message)
      }
    },
    /**
     * closeInterestModal
     */
    closeRoleEditModal () {
      this.showRoleEditModal = false
      this.$emit("emitCloseRoleEditModal", true)
    },
    /**
     * Returns the filtered list based on the search input
     */
    getFilteredActions () {
      if (!this.filter) {
        return this.udfActionOptions
      }
      return this.udfActionOptions.filter(action =>
        action.action_name && action.action_name.toLowerCase().includes(this.filter.toLowerCase())
      )
    }
  },
  watch: {
    async propShowRoleEditModal () {
      if (this.propShowRoleEditModal) {
        this.loadRequiredData()
        this.showRoleEditModal = true
      }
    }
  }
}
</script>
